import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-cloud',
  standalone: true,
  templateUrl: './rt-icon-cloud.component.html',
  styleUrls: ['./rt-icon-cloud.component.scss']
})
export class RtIconCloudComponent {
  @Input() width: number | string = 17;
  @Input() height: number | string = 12;
}
